import TaxiCorporationUnbilledOrdersListRequest, {
  TaxiCorporationUnbilledOrdersListQueryParams,
} from "./taxi-corporation-unbilled-orders-list.request";

const createQueryParams = (
  request: TaxiCorporationUnbilledOrdersListRequest,
): TaxiCorporationUnbilledOrdersListQueryParams => {
  return {
    limit: request.limit,
    address: request.address,
    client: request.client,
    dispatch: request.dispatch,
    driver: request.driver,
    endAddress: request.endAddress,
    excludeCargoCompany: request.excludeCargoCompany,
    externalId: request.externalId,
    humanId: request.humanId,
    isCancelled: request.isCancelled,
    midAddress: request.midAddress,
    offset: request.offset,
    order: request.order,
    passenger: request.passenger,
    startAddress: request.startAddress,
    startTimeSince: request.startTimeSince,
    startTimeTo: request.startTimeTo,
    taxi: request.taxi,
  };
};

const taxiCorporationUnbilledOrdersListRequestFactory = {
  createQueryParams,
};

export default taxiCorporationUnbilledOrdersListRequestFactory;
